<div [ngClass]="'status ' + color">{{ label | translate }}</div>
